import { SaveAlt } from '@mui/icons-material';
import { Box, Button } from '@mui/material';
import React from 'react';
import { BookingService, CustomerService } from './Service';
import Swal from 'sweetalert2';
import { formatDateTime } from '../../utils/dateUtils';
import dayjs from 'dayjs';
import { usePermission } from '../../hooks/usePermission';


const ExportIncomleteProfile = (props) => {
  const { paginationModel, columns, statusOptions } = props;
  const customerListExportPermission = usePermission('customer-list-export');

  // Define custom headers and their corresponding data mapping
    const exportMapping = [
      {
        header: 'Customer Id',
        value: (row) => `${row.id}`
      },
      { 
        header: 'Mobile Number',
        value: (row) => `${row?.mobileNumber || ''}`
      },
      {
        header: 'Creation Date',
        value: (row) => formatDateTime(row.createdAt)
      }
    ];

  // Custom export function for server-side pagination

  const handleExportAllRows = async (options) => {
    try {
      // Show loading notification
      Swal.fire({
        title: 'Exporting Data',
        text: 'Please wait while we prepare your download...',
        icon: 'info',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });
      
      const listResponse = await CustomerService.customerListToExport(
        {
        filters: {
          searchKey: paginationModel.filters.searchKey,
          sortKey: paginationModel.filters.sortKey,
          sortDirection: paginationModel.filters.sortDirection,
          filterOptions: paginationModel.filters.filterOptions || []
        }
      },'in-complete'
    );
  
    // Prepare export data
    const exportData = listResponse.data.customers.map(row => {
            return exportMapping.reduce((acc, field) => {
              acc[field.header] = field.value(row);
              return acc;
            }, {});
          });
    
          // Create CSV content
          const headers = exportMapping.map(field => `"${field.header}"`).join(',');
          const csvContent = exportData.map(row => 
            exportMapping.map(field => 
              `"${String(row[field.header] ?? '').replace(/"/g, '""')}"`
            ).join(',')
          );
    
          csvContent.unshift(headers);
    
          // Create and download file
          const csvString = csvContent.join('\n');
          const blob = new Blob([csvString], { type: 'text/csv;charset=utf-8;' });
          const url = URL.createObjectURL(blob);
    
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'Incomplete-profile-Customer-Report.csv');
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
    
          Swal.fire({
            title: 'Export Successful',
            html: `
              <p>If download doesn't start automatically, click on provided link:
              <a href="${url}" download="customer-report.csv" style="color: blue; text-decoration: underline;">
                Download CSV
              </a></p>
            `,
            icon: 'success',
            showConfirmButton: true,
            confirmButtonText: 'Close'
          });
    
    } catch (error) {
      console.error('Export failed', error);
      
      Swal.fire({
        title: 'Export Failed',
        text: 'There was an issue exporting the data. Please try again.',
        icon: 'error'
      });
    }
  };
return (
  <>
 {customerListExportPermission.canView &&(
  <Box>        
      <Button 
          onClick={handleExportAllRows}
          startIcon={<SaveAlt />}
          sx={{textTransform:'none'}}
      >
          Export
      </Button>      
  </Box>
 )}
   </>
);
}

export default ExportIncomleteProfile;
